export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-stretch overflow-hidden">
      {/* Split background */}
      <div className="absolute inset-0 flex">
        <div className="w-full md:w-[55%] bg-charcoal" />
        <div className="hidden md:block md:w-[45%] relative overflow-hidden">
          <img
            src="https://public.readdy.ai/ai/img_res/59523f59d97eb9b1d8cd9586904a0134.jpg"
            alt="Strahlendes Lächeln – Flow & Glow Köln"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-charcoal/40 to-transparent" />
        </div>
      </div>

      {/* Mobile background image */}
      <div className="md:hidden absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=beautiful%20woman%20with%20perfect%20radiant%20white%20smile%2C%20soft%20warm%20golden%20lighting%2C%20close%20up%20beauty%20portrait%2C%20blush%20rose%20tones%2C%20elegant%20and%20natural%20expression%2C%20warm%20skin%20tones%2C%20lifestyle%20beauty%20photography%2C%20shallow%20depth%20of%20field%2C%20professional%20studio%20light%2C%20pure%20and%20inviting%2C%20feminine%20energy%2C%20high%20end%20beauty%20boutique&width=900&height=1200&seq=101&orientation=portrait"
          alt="Strahlendes Lächeln"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-charcoal/75" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full flex items-center">
        <div className="max-w-7xl mx-auto px-4 md:px-8 w-full pt-24 md:pt-0">
          <div className="w-full md:w-[55%] flex flex-col items-center md:items-start justify-center text-center md:text-left min-h-screen py-20">

            {/* Headline */}
            <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl font-medium text-white leading-tight mb-6">
              Dein Lächeln
              <br />
              <em style={{ fontStyle: 'italic', color: '#d4a08a' }}>zählt.</em>
            </h1>

            {/* Subline */}
            <p className="font-sans text-base md:text-lg text-white/70 leading-relaxed mb-10 max-w-md mx-auto md:mx-0 md:max-w-lg">
              Kosmetische Zahnaufhellung in Köln. Schmerzfrei. Professionell. Strahlend.
            </p>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
              <a
                href="https://simplybook.me"
                target="_blank"
                rel="nofollow noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-rose hover:bg-rose-dark text-white font-sans font-medium text-base px-8 py-4 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer w-full sm:w-auto"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-calendar-line text-base" />
                </span>
                Termin buchen
              </a>
              <a
                href="#leistungen"
                className="hidden sm:inline-flex items-center justify-center gap-2 border border-white/30 hover:border-white/60 text-white font-sans font-medium text-base px-8 py-4 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Leistungen entdecken
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-down-line text-base" />
                </span>
              </a>
            </div>

            {/* Scroll indicator */}
            <div className="hidden md:flex items-center gap-3 mt-16">
              <div className="w-8 h-px bg-white/30" />
              <span className="font-sans text-xs text-white/40 tracking-widest uppercase">Scroll</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
